import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-container inspection" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "header" }, "Inspection Summary")
], -1)
const _hoisted_3 = { class: "customer" }
const _hoisted_4 = { class: "container summary" }
const _hoisted_5 = { class: "wo-details" }
const _hoisted_6 = { class: "customer" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "Customer:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Vehicle:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "Plate:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Odometer:", -1)
const _hoisted_11 = {
  class: "p-datatable p-component p-datatable-responsive-stack p-datatable-striped",
  "data-scrollselectors": ".p-datatable-wrapper"
}
const _hoisted_12 = {
  class: "p-datatable-header",
  style: {"border-radius":"25px 25px 0px 0px !important"}
}
const _hoisted_13 = { class: "flex flex-wrap align-items-center justify-content-between gap-2" }
const _hoisted_14 = { style: {"margin-bottom":"0px"} }
const _hoisted_15 = { class: "p-datatable-wrapper" }
const _hoisted_16 = {
  role: "table",
  class: "p-datatable-table"
}
const _hoisted_17 = {
  class: "p-datatable-thead",
  role: "rowgroup"
}
const _hoisted_18 = { role: "row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("th", {
  class: "item",
  role: "cell",
  style: {"border-radius":"0px !important"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-column-header-content" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "p-column-title" }, "Item")
  ])
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "p-column-title" }, "Result", -1)
const _hoisted_21 = {
  key: 0,
  class: "p-sortable-column-icon pi pi-fw pi-sort-alt"
}
const _hoisted_22 = {
  key: 1,
  class: "p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt"
}
const _hoisted_23 = {
  key: 2,
  class: "p-sortable-column-icon pi pi-fw pi-sort-amount-down"
}
const _hoisted_24 = {
  class: "p-datatable-tbody",
  role: "rowgroup"
}
const _hoisted_25 = {
  class: "item",
  role: "cell"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "p-column-title" }, "Item", -1)
const _hoisted_27 = {
  key: 0,
  class: "row",
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_28 = {
  class: "title",
  style: {"flex-grow":"1"}
}
const _hoisted_29 = {
  key: 1,
  class: "row",
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_30 = {
  class: "title",
  style: {"flex-grow":"1"}
}
const _hoisted_31 = { class: "title" }
const _hoisted_32 = {
  key: 0,
  class: "notes",
  style: {"margin-left":"2rem"}
}
const _hoisted_33 = { style: {"margin-bottom":"0"} }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("strong", null, "Comment:", -1)
const _hoisted_35 = {
  key: 1,
  class: "notes",
  style: {"margin-left":"2rem"}
}
const _hoisted_36 = { style: {"margin-bottom":"0"} }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("strong", null, "Notes:", -1)
const _hoisted_38 = {
  key: 2,
  class: "notes",
  style: {"margin-left":"2rem"}
}
const _hoisted_39 = { style: {"margin-bottom":"0"} }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("strong", null, "Internal Notes:", -1)
const _hoisted_41 = {
  key: 3,
  class: "notes",
  style: {"margin-left":"2rem"}
}
const _hoisted_42 = { style: {"margin-bottom":"0"} }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("strong", null, "Measurements: ", -1)
const _hoisted_44 = {
  key: 4,
  class: "documents",
  style: {"margin-left":"2rem"}
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"0"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Upload(s):")
], -1)
const _hoisted_46 = /*#__PURE__*/_createTextVNode("X")
const _hoisted_47 = {
  key: 1,
  class: "video-container"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-play" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createTextVNode("X")
const _hoisted_50 = {
  class: "result",
  role: "cell"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("img", {
  class: "modal-content",
  id: "previewNoVideo",
  src: "/default_no_video.png",
  alt: "Image",
  style: {"display":"none"}
}, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("video", {
  class: "modal-content",
  id: "previewVideo",
  style: {"display":"none"},
  controls: "",
  autoplay: ""
}, [
  /*#__PURE__*/_createElementVNode("source")
], -1)

import { computed, onMounted } from 'vue';
import { ref } from "@vue/reactivity";
import { WorkOrderPackage } from '../store/state';
import { useRouter } from 'vue-router';
import { useAuth0 } from "@auth0/auth0-vue";
import { MutationTypes } from "../store/mutations";
import { useStore } from "../store";
import { useToast } from 'primevue/usetoast';
import Image from 'primevue/image';
import ErrorModal from './ErrorModal.vue';
import { openErrorModal } from '@/composables/useErrorLog';


export default /*#__PURE__*/_defineComponent({
  name: 'DVISummaryWorkOrderPackage',
  setup(__props) {

const store = useStore();
const auth0 = useAuth0();
const router = useRouter();
const toast = useToast();
const workorderpackageid = computed(() => store.state.currentWorkOrderPackageID);
const workorderpackageheader = computed(() => store.state.currentWorkOrderPackageHeader);
const workorderid = ref('');
const workordernumber = ref('');
const lastname = ref('');
const firstname = ref('');
const make = ref('');
const model = ref('');
const color = ref('');
const plate = ref('');
const usage = ref();
const UsageComputed = computed(() => new Intl.NumberFormat().format(usage.value));
const Username = ref('');
let currentWorkOrderPackage: WorkOrderPackage[] | undefined = [];
const currentWorkOrderPackageInspectionLinesRef = ref();
const sortResult = ref('');
const currentDVIWO = computed(() => store.state.currentdviwoitem);
const dataSorted = ref([]);
const loading = ref(false);
const checkResults = computed(() => {
    return currentWorkOrderPackageInspectionLinesRef.value === undefined ? false :
        currentWorkOrderPackageInspectionLinesRef.value
        .filter((item) => item.Type === 'Line')
        .every((item) => item.Result.trim() !== '');
})

/**
 * Set data, filter work orders and packages
 */
onMounted(async () => {
    window.addEventListener('scroll', handleScroll);

    Username.value = store.state.username;

    if (currentDVIWO.value !== undefined) {
        workorderid.value = currentDVIWO.value?.WorkOrderID;
        workordernumber.value = currentDVIWO.value?.WorkOrderNumber.toString();
        lastname.value = currentDVIWO.value?.LastName;
        firstname.value = currentDVIWO.value?.FirstName;
        make.value = currentDVIWO.value?.Make;
        model.value = currentDVIWO.value?.Model;
        color.value = currentDVIWO.value?.Color;
        plate.value = currentDVIWO.value?.Plate;
        usage.value = currentDVIWO.value?.InUsage;
    }

    currentWorkOrderPackage = currentDVIWO.value?.WorkOrderPackages?.filter(obj => obj.WorkOrderPackageID === workorderpackageid.value);
    if (currentWorkOrderPackage !== undefined) {
        currentWorkOrderPackageInspectionLinesRef.value = currentWorkOrderPackage[0].WorkOrderPackageInspectionLines;
    } else {
        currentWorkOrderPackageInspectionLinesRef.value = [];
    }
});

/**
 * To display tob button
 */
const handleScroll = () => {
    const topButton = document.getElementById("topBtn");
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        topButton.style.display = "flex";
    } else {
        topButton.style.display = "none";
    }
}

/**
 * Makes the page to move at the top
 */
const topFunction = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}

/**
 * Navigate to update page if handleEdit has been clicked
 */
const handleEdit = () => {
    router.push({ name: 'dviupdateworkorderpackage', params: { workorderpackageid: workorderpackageid.value, workorderpackageheader: workorderpackageheader.value } });
}

/**
 * Actual saving of the data
 */
 const handleSubmit = async () => {
    if (currentWorkOrderPackage !== undefined) {
        loading.value = true;
        currentWorkOrderPackage[0].WorkOrderPackageInspectionLines = currentWorkOrderPackageInspectionLinesRef.value;
        store.commit(MutationTypes.UPDATE_DVIWOPACKAGE, { WorkOrderNumber: workordernumber.value, WorkOrderPackageID: workorderpackageid.value, WorkOrderPackage: currentWorkOrderPackage[0] });
        
        const storeid = store.state.storeid;
        const apiserver = process.env.VUE_APP_NODEJS_BASE_URL;
        const url = apiserver + "dviworkorders/" + storeid + "/" + workorderid.value + "/" + workorderpackageid.value;
        const origin = new URL(apiserver).origin;

        //post json from state to integration api
        let WorkOrderPackageInspectionLinesdata = {
            WorkOrderPackageInspectionLines: currentWorkOrderPackage[0].WorkOrderPackageInspectionLines,
            resultPageURL: origin + "/results.html"
        };

        try {
            const accessToken = await auth0.getAccessTokenSilently();
            const response: Response = await fetch(url, {
                method: 'PATCH',
                body: JSON.stringify(WorkOrderPackageInspectionLinesdata),
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                },
            });

            const data = await response.json();
            if (response.status > 400) {
                throw new Error(JSON.stringify(data.error));
            }
            const popupmessage = checkResults.value ? 'Inspection marked as Completed.' : 'Inspection has been Saved.';
            toast.add({ severity: 'success', summary: 'Successful', detail: popupmessage, life: 3000 });
            loading.value = false;
        } catch (e) {
            openErrorModal(e.message);
            loading.value = false;
        }
    }
}

/**
 * Cancel will navigate the user to dviworkorderpackages view component 
 */
function handleCancel() {
    router.push({ name: 'dviworkorderpackages', params: { workordernumber: workordernumber.value, workorderid: workorderid.value } });
}

/**
 * Delete Image in S3
 * @param WorkOrderPackageInspectionLineID 
 * @param Imageindex 
 * @param ImageFullUrl 
 */
const deleteImage = async (WorkOrderPackageInspectionLineID: string, Imageindex: number, ImageFullUrl: string) => {
    deleteImageInVuex(Imageindex, WorkOrderPackageInspectionLineID);
    //delete image from db through integration API
    await deleteImageIntegrationAPI(WorkOrderPackageInspectionLineID, ImageFullUrl);
    await deleteImageInAWSS3(ImageFullUrl);
}

/**
 * Delete image in vuex
 * @param ImageFullUrl 
 */
 const deleteImageInVuex = (index: number, WorkOrderPackageInspectionLineID: string) => {
    //delete image from array ref memory
    currentWorkOrderPackageInspectionLinesRef.value.filter(obj => obj.WorkOrderPackageInspectionLineID === WorkOrderPackageInspectionLineID)[0].MediaKeys.splice(index, 1);

    //delete image from VUEX state
    if (currentWorkOrderPackage !== undefined) {
        currentWorkOrderPackage[0].WorkOrderPackageInspectionLines = currentWorkOrderPackageInspectionLinesRef.value;

        //update currentWorkOrderPackage in state
        store.commit(MutationTypes.UPDATE_DVIWOPACKAGE, { WorkOrderNumber: workordernumber.value, WorkOrderPackageID: workorderpackageid.value, WorkOrderPackage: currentWorkOrderPackage[0] });
    }
}

/**
 * Delete image in API server
 * @param WorkOrderPackageInspectionLineID 
 * @param ImageFullUrl 
 */
 const deleteImageIntegrationAPI = async (WorkOrderPackageInspectionLineID: string, ImageFullUrl: string) => {
    let mediadata = {
        MediaKey: ImageFullUrl,
        Username: Username.value
    };

    
    const storeid = store.state.storeid;
    const url = process.env.VUE_APP_NODEJS_BASE_URL + "dviworkorders/s3mediakey/" + storeid + "/" + WorkOrderPackageInspectionLineID;

    try {
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(url, {
            method: 'PATCH',
            body: JSON.stringify(mediadata),
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
    } catch (e) {
        openErrorModal(e.message);
    }
}

/**
 * Delete image in AWS S3
 * @param ImageFullUrl 
 */
 const deleteImageInAWSS3 = async (ImageFullUrl: string) => {
    const storeid = store.state.storeid;
    const deletedMediaKey = ImageFullUrl.split("/")[5];
    const s3url = process.env.VUE_APP_NODEJS_BASE_URL + "s3/deleteobject/" + storeid + "/"  + workordernumber.value + "/" + deletedMediaKey;
    try {
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(s3url, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
    } catch (e) {
        openErrorModal(e.message);
    }
}

/**
 * To open video popup
 * @param event 
 * @param media 
 */
const openVideoPopup = async (event, media) => {

    if (event.target.src.endsWith('/default_no_video.png') === true) {
        return;
    }
    
    const modalImage = document.getElementById("previewNoVideo");
    modalImage.style.display = 'none';

    const previewModal = document.getElementById("PreviewModal");
    previewModal.style.display = 'block';

    const modalVideo = document.getElementById("previewVideo");
    modalVideo.style.display = 'block';

    const baseUrl = getVideo(media); // https://api-files.sproutvideo.com/file/0690d2b11d1aefcf8f/7d38b83fb71f18a6/
    const resolutions = ["720", "480", "360", "240"];
    const videoAssets = resolutions.map(resolution => `${baseUrl}${resolution}.mp4`);
    let isValid = false;
    for (let index=0; index < videoAssets.length; index++) {
        const response = await fetch(videoAssets[index]);
        if (response.status >= 200 && response.status < 400) {
            modalVideo.src = videoAssets[index];
            isValid = true;
            break; // this is to stop the iteration
        }
    }
    
    if (isValid === false) {
        modalVideo.style.display = 'none';
        modalImage.style.display = 'block';
    }
}

/**
 * To close popup video
 */
const closeVideoPopup = () => {
    let previewModal = document.getElementById("PreviewModal");
    previewModal.style.display = 'none';
    let modalVideo = document.getElementById("previewVideo");
    modalVideo.src = null;
}

/**
 * Split the media file and return thumbnail
 * @param media 
 */
const getThumbnail = (media: string) => {
    return media.split('|')[0];
}

/**
 * Get video of given string
 * @param media 
 */
const getVideo = (media: string) => {
    return media.split('|')[1];
}

/**
 * Actual delete of video
 * @param WorkOrderPackageInspectionLineID 
 * @param mediaKeyIndex 
 * @param media 
 */
const deleteVideo = async (WorkOrderPackageInspectionLineID: string, mediaKeyIndex: number, media: string) => {
    const videoUrl = getVideo(media);
    
    // get video id using video url
    const videoArray = videoUrl.split('/');
    const videoID = videoArray[videoArray.length - 3];

    deleteVideoInVuex(WorkOrderPackageInspectionLineID, mediaKeyIndex);
    //delete image from db through integration API
    await deletVideoIntegrationAPI(WorkOrderPackageInspectionLineID, media);
    await deleteVideoInSproutAPI(videoID);
}

/**
 * deletVideoOnIntegrationAPI
 * @param WorkOrderPackageInspectionLineID 
 * @param media 
 */
const deletVideoIntegrationAPI = async (WorkOrderPackageInspectionLineID: string, media: string) => {
    let mediadata = {
        MediaKey: media,
        Username:Username.value
    };

    
    const storeid = store.state.storeid;
    const url = process.env.VUE_APP_NODEJS_BASE_URL + "dviworkorders/s3mediakey/" + storeid + "/" + WorkOrderPackageInspectionLineID;

    try {
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(url, {
            method: 'PATCH',
            body: JSON.stringify(mediadata),
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
    } catch (e) {
        openErrorModal(e.message);
    }
}

/**
 * Delete video in vuex
 * @param WorkOrderPackageInspectionLineID 
 * @param mediaKeyIndex
 */
const deleteVideoInVuex = (WorkOrderPackageInspectionLineID: string, mediaKeyIndex: number) => {
    //delete image from array ref memory
    currentWorkOrderPackageInspectionLinesRef.value.filter((obj) => obj.WorkOrderPackageInspectionLineID === WorkOrderPackageInspectionLineID)[0].MediaKeys.splice(mediaKeyIndex, 1);

    //delete image from VUEX state
    if (currentWorkOrderPackage !== undefined) {
        currentWorkOrderPackage[0].WorkOrderPackageInspectionLines = currentWorkOrderPackageInspectionLinesRef.value;
        //update currentWorkOrderPackage in state
        store.commit(MutationTypes.UPDATE_DVIWOPACKAGE, { WorkOrderNumber: workordernumber.value, WorkOrderPackageID: workorderpackageid.value, WorkOrderPackage: currentWorkOrderPackage[0] });
    }
}

/**
 * Delete video in sprout API
 * @param videoID 
 */
const deleteVideoInSproutAPI = async (videoID: string) => {
    try {
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + 'videos/' + videoID, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
    } catch (e) {
        openErrorModal(e.message);
    }
}

const handleImageError = (inspectionIndex, mediaKeyIndex, srcImg) => {
    const errorImage: HTMLImageElement | null = document.querySelector(`img[inspection-index="${inspectionIndex}"][media-index="${mediaKeyIndex}"]`);
    if (errorImage) {
        errorImage.src = srcImg;
    }
}

/**
 * Changes the sorting value if the user clicks on the result sorting icon
 */
 const handleSorting = () => {
    switch(sortResult.value) {
        case '': sortResult.value = 'asc'
            break;
        case 'asc': sortResult.value = 'desc'
            break;
        case 'desc': sortResult.value = ''
            break;
    }
}

/**
 * Put the item on the last if the type is header
 * desc, required is the highest
 * asc, required is the lowest
 * @param a 
 * @param b 
 */
const customSort = (a, b) => {
    let order = { Required: 1, Suggested: 2, OK: 3, '': 4 };
    if (sortResult.value === 'desc') {
        order = { Required: 4, Suggested: 3, OK: 2, '': 1 };
    }
    if (a.Type === 'Header') return 1;
    if (b.Type === 'Header') return -1;
    return order[a.Result] - order[b.Result];
};

/**
 * Return original sorting which is by Rank
 * Rank is the property which considered as index in API response
 * @param a 
 * @param b 
 */
const originalSorting = (a, b) => {
    return a.Rank - b.Rank; 
}

/**
 * Sort data original, custom ascending and descending
 * @param data 
 */
const sortData = (data) => {
    if(!data) {
        dataSorted.value = [];
        return [];
    }
    if (data && sortResult.value === '') {
        const sortedData = data.sort(originalSorting);
        dataSorted.value = sortedData;
        return sortedData;
    }
    const sortedData = data.sort(customSort);
    dataSorted.value = sortedData;
    return sortedData;
}

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ErrorModal),
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          onClick: handleEdit,
          label: "Continue Editing",
          class: "p-button p-component p-button-rounded btn-secondary"
        }),
        _createVNode(_component_Button, {
          onClick: handleSubmit,
          loading: loading.value,
          label: _unref(checkResults) ? 'Submit Inspection' : 'Save Inspection',
          class: "p-button p-component p-button-rounded btn-primary ml-2"
        }, null, 8, ["loading", "label"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: handleCancel,
          class: "p-button p-component p-button-rounded btn-primary sml flex"
        }, "Workorder " + _toDisplayString(workordernumber.value), 1),
        _createElementVNode("p", _hoisted_6, [
          _createElementVNode("span", null, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(firstname.value) + " " + _toDisplayString(lastname.value), 1)
          ]),
          _createElementVNode("span", null, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(color.value) + " " + _toDisplayString(make.value) + " " + _toDisplayString(model.value), 1)
          ]),
          _createElementVNode("span", null, [
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(plate.value), 1)
          ]),
          _createElementVNode("span", null, [
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(_unref(UsageComputed)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h4", _hoisted_14, [
              _createElementVNode("strong", null, _toDisplayString(_unref(workorderpackageheader)) + " Summary", 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("table", _hoisted_16, [
            _createElementVNode("thead", _hoisted_17, [
              _createElementVNode("tr", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("th", {
                  onClick: handleSorting,
                  class: "result",
                  role: "cell",
                  style: {"cursor":"pointer","border-radius":"0px !important"}
                }, [
                  _createElementVNode("div", {
                    style: _normalizeStyle([{color: sortResult.value != '' ? '#2196F3' : ''}, {"width":"6rem","line-height":"1.5"}]),
                    class: "result"
                  }, [
                    _hoisted_20,
                    (sortResult.value === '')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21))
                      : _createCommentVNode("", true),
                    (sortResult.value === 'asc')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                      : _createCommentVNode("", true),
                    (sortResult.value === 'desc')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23))
                      : _createCommentVNode("", true)
                  ], 4)
                ])
              ])
            ]),
            _createElementVNode("tbody", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortData(currentWorkOrderPackageInspectionLinesRef.value), (InspectionLine, inspectionIndex) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: inspectionIndex,
                  class: "",
                  role: "row",
                  draggable: "false",
                  style: _normalizeStyle({ display: (InspectionLine.Type === 'Header' && sortResult.value !== '') ? 'none' : '' })
                }, [
                  _createElementVNode("td", _hoisted_25, [
                    _hoisted_26,
                    (InspectionLine.Type === 'Header' && sortResult.value === '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("strong", null, _toDisplayString(InspectionLine.Title), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (InspectionLine.Type === 'Line')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("h4", _hoisted_31, _toDisplayString(InspectionLine.Title), 1),
                            (InspectionLine.Comment)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  _createElementVNode("p", _hoisted_33, [
                                    _hoisted_34,
                                    _createTextVNode(" " + _toDisplayString(InspectionLine.Comment), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (InspectionLine.Notes)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _createElementVNode("p", _hoisted_36, [
                                    _hoisted_37,
                                    _createTextVNode(" " + _toDisplayString(InspectionLine.Notes), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (InspectionLine.ShopNotes)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                  _createElementVNode("p", _hoisted_39, [
                                    _hoisted_40,
                                    _createTextVNode(" " + _toDisplayString(InspectionLine.ShopNotes), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (InspectionLine.Unit !== '')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                  _createElementVNode("p", _hoisted_42, [
                                    _hoisted_43,
                                    _createTextVNode(" LF: " + _toDisplayString(InspectionLine.LF + InspectionLine.UnitText) + " RF: " + _toDisplayString(InspectionLine.RF + InspectionLine.UnitText) + " LR: " + _toDisplayString(InspectionLine.LR + InspectionLine.UnitText) + " RR: " + _toDisplayString(InspectionLine.RR + InspectionLine.UnitText), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (InspectionLine.MediaKeys.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                  _hoisted_45,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(InspectionLine.MediaKeys, (media, mediaKeyIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "p-image p-image-preview-container item-image",
                                      key: mediaKeyIndex,
                                      style: {"margin-right":"1.5rem"}
                                    }, [
                                      (media.includes('|') === false)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createVNode(_unref(Image), {
                                              "inspection-index": inspectionIndex,
                                              "media-index": mediaKeyIndex,
                                              class: "p-overlay-badge",
                                              alt: "Image",
                                              width: "150",
                                              preview: "",
                                              src: media,
                                              onError: ($event: any) => (handleImageError(inspectionIndex, mediaKeyIndex, '/default_no_image.png'))
                                            }, null, 8, ["inspection-index", "media-index", "src", "onError"]),
                                            _createVNode(_component_Button, {
                                              class: "p-button p-button-rounded btn-danger sml delete",
                                              onClick: ($event: any) => (deleteImage(InspectionLine.WorkOrderPackageInspectionLineID, mediaKeyIndex, media))
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_46
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ], 64))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                            _hoisted_48,
                                            _createVNode(_unref(Image), {
                                              "inspection-index": inspectionIndex,
                                              "media-index": mediaKeyIndex,
                                              alt: "Image",
                                              width: "150",
                                              src: getThumbnail(media),
                                              onClick: event => openVideoPopup(event, media),
                                              onError: ($event: any) => (handleImageError(inspectionIndex, mediaKeyIndex, '/default_no_video.png'))
                                            }, null, 8, ["inspection-index", "media-index", "src", "onClick", "onError"]),
                                            _createVNode(_component_Button, {
                                              class: "p-button p-button-rounded btn-danger sml delete",
                                              onClick: ($event: any) => (deleteVideo(InspectionLine.WorkOrderPackageInspectionLineID, mediaKeyIndex, media))
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_49
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ]))
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_50, [
                    (InspectionLine.Type === 'Line')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass('customer-badge status-' + InspectionLine.Result)
                        }, _toDisplayString(InspectionLine.Result), 3))
                      : _createCommentVNode("", true)
                  ])
                ], 4))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "preview-modal",
      id: "PreviewModal"
    }, [
      _createElementVNode("span", {
        class: "close",
        id: "closeButton",
        onClick: closeVideoPopup
      }, "×"),
      _hoisted_51,
      _hoisted_52
    ]),
    _createVNode(_component_Button, {
      onClick: topFunction,
      id: "topBtn",
      icon: "pi pi-arrow-up",
      class: "p-button-rounded",
      "aria-label": "Go to Top"
    })
  ], 64))
}
}

})